(function () {
    'use strict';

    var CONFIG = {
        mapCenter: [39.8283, -98.5795],
        mapZoom: 4,
        markerIconUrl: 'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="24" height="36"><path fill="#c53030" stroke="#8b0000" stroke-width="1" d="M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24c0-6.6-5.4-12-12-12z"/><circle fill="#fff" cx="12" cy="11" r="4"/></svg>'),
        nominatimUrl: 'https://nominatim.openstreetmap.org/search'
    };

    function ParasStoreLocator(container) {
        this.container = container;
        this.stores = [];
        this.filteredStores = [];
        this.map = null;
        this.markers = [];
        this.markerGroup = null;
        this.searchLocation = null;
        this.init();
    }

    ParasStoreLocator.prototype.init = function () {
        var self = this;
        this.loadStores()
            .then(function () {
                self.initMap();
                self.initSearch();
                self.renderStoreList();
                self.addMarkers();
            })
            .catch(function (error) {
                console.error('Store Locator error:', error);
                self.showError('Unable to load store locations.');
            });
    };

    ParasStoreLocator.prototype.loadStores = function () {
        var self = this;
        var dataUrl = this.container.dataset.storesUrl;
        if (!dataUrl) {
            return Promise.reject(new Error('No stores data URL found'));
        }
        return fetch(dataUrl)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Failed to fetch stores');
                }
                return response.json();
            })
            .then(function (data) {
                self.stores = data.filter(function (store) {
                    return store.lat && store.lng && !isNaN(store.lat) && !isNaN(store.lng);
                });
                self.stores.sort(function (a, b) {
                    return (a.name || '').localeCompare(b.name || '');
                });
                self.filteredStores = self.stores.slice();
            });
    };

    ParasStoreLocator.prototype.initMap = function () {
        var mapContainer = this.container.querySelector('#paras-map');
        if (!mapContainer || typeof L === 'undefined') return;
        this.map = L.map(mapContainer, {
            center: CONFIG.mapCenter,
            zoom: CONFIG.mapZoom,
            scrollWheelZoom: true,
            zoomControl: true
        });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap',
            maxZoom: 19
        }).addTo(this.map);
        this.markerGroup = L.featureGroup().addTo(this.map);
        this.fitMapToStores();
    };

    ParasStoreLocator.prototype.initSearch = function () {
        var self = this;
        var searchInput = this.container.querySelector('.paras-store-search-input');
        var searchBtn = this.container.querySelector('.paras-store-search-button');
        if (searchInput) {
            searchInput.addEventListener('input', function () {
                self.performSearch(searchInput.value);
            });
            searchInput.addEventListener('keypress', function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    self.performSearch(searchInput.value);
                }
            });
        }
        if (searchBtn) {
            searchBtn.addEventListener('click', function () {
                self.performSearch(searchInput ? searchInput.value : '');
            });
        }
    };

    ParasStoreLocator.prototype.performSearch = function (query) {
        var self = this;
        query = (query || '').trim().toLowerCase();

        if (!query) {
            this.filteredStores = this.stores.slice();
            this.renderStoreList();
            this.updateMarkers();
            this.fitMapToStores();
            return;
        }

        var textMatches = this.stores.filter(function (store) {
            var searchFields = [
                store.name || '',
                store.city || '',
                store.state || '',
                store.postalCode || '',
                store.address1 || ''
            ].join(' ').toLowerCase();
            return searchFields.indexOf(query) !== -1;
        });

        if (textMatches.length > 0) {
            this.filteredStores = textMatches;
            this.renderStoreList();
            this.updateMarkers();
            if (this.filteredStores.length === 1) {
                var store = this.filteredStores[0];
                this.map.setView([store.lat, store.lng], 12);
            } else {
                this.fitMapToStores();
            }
        } else {
            this.geocodeAndSearch(query);
        }
    };

    ParasStoreLocator.prototype.geocodeAndSearch = function (query) {
        var self = this;
        this.geocodeAddress(query)
            .then(function (location) {
                if (!location) {
                    self.filteredStores = [];
                    self.renderStoreList();
                    self.updateMarkers();
                    return;
                }
                self.searchLocation = location;
                self.filteredStores = self.stores.map(function (store) {
                    return Object.assign({}, store, {
                        distance: self.calculateDistance(location.lat, location.lng, store.lat, store.lng)
                    });
                }).sort(function (a, b) { return a.distance - b.distance; });
                self.renderStoreList(true);
                self.updateMarkers();
                self.map.setView([location.lat, location.lng], 8);
            })
            .catch(function () {
                self.filteredStores = [];
                self.renderStoreList();
                self.updateMarkers();
            });
    };

    ParasStoreLocator.prototype.geocodeAddress = function (address) {
        var url = new URL(CONFIG.nominatimUrl);
        url.searchParams.set('q', address);
        url.searchParams.set('format', 'json');
        url.searchParams.set('limit', '1');
        url.searchParams.set('countrycodes', 'us,ca,gb,au,de');
        return fetch(url.toString())
            .then(function (response) {
                if (!response.ok) throw new Error('Geocoding failed');
                return response.json();
            })
            .then(function (data) {
                if (data && data.length > 0) {
                    return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
                }
                return null;
            });
    };

    ParasStoreLocator.prototype.calculateDistance = function (lat1, lng1, lat2, lng2) {
        var R = 3959;
        var dLat = (lat2 - lat1) * Math.PI / 180;
        var dLng = (lng2 - lng1) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    ParasStoreLocator.prototype.renderStoreList = function (showDistance) {
        var listContainer = this.container.querySelector('.paras-store-list-items');
        if (!listContainer) return;
        if (this.filteredStores.length === 0) {
            listContainer.innerHTML = '<div class="paras-store-empty"><p>No stores found.</p></div>';
            this.updateResultsCount();
            return;
        }
        var self = this;
        listContainer.innerHTML = this.filteredStores.map(function (store, index) {
            var html = '<li class="paras-store-card" data-store-index="' + index + '" data-store-id="' + store.id + '">';
            html += '<div class="paras-store-card-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36"><path fill="currentColor" d="M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24c0-6.6-5.4-12-12-12z"/><circle fill="#fff" cx="12" cy="11" r="4"/></svg></div>';
            html += '<div class="paras-store-card-info">';
            html += '<h3 class="paras-store-card-name">' + self.escapeHtml(store.name) + '</h3>';
            html += '<div class="paras-store-card-address">';
            if (store.address1) html += self.escapeHtml(store.address1) + '<br>';
            if (store.city) html += self.escapeHtml(store.city) + ', ';
            if (store.state) html += self.escapeHtml(store.state) + ' ';
            if (store.postalCode) html += self.escapeHtml(store.postalCode);
            html += '<br>';
            if (store.country) html += self.escapeHtml(store.country);
            html += '</div>';
            if (store.phone) html += '<a href="tel:' + store.phone + '" class="paras-store-card-phone">' + self.escapeHtml(store.phone) + '</a>';
            if (showDistance && store.distance) html += '<div class="paras-store-card-distance">' + store.distance.toFixed(1) + ' mi</div>';
            html += '</div></li>';
            return html;
        }).join('');
        listContainer.querySelectorAll('.paras-store-card').forEach(function (card) {
            card.addEventListener('click', function () {
                var index = parseInt(card.dataset.storeIndex);
                self.selectStore(index);
            });
        });
        this.updateResultsCount();
    };

    ParasStoreLocator.prototype.addMarkers = function () {
        var self = this;
        var customIcon = L.icon({
            iconUrl: CONFIG.markerIconUrl,
            iconSize: [24, 36],
            iconAnchor: [12, 36],
            popupAnchor: [0, -36]
        });
        this.markers = this.filteredStores.map(function (store, index) {
            var marker = L.marker([store.lat, store.lng], { icon: customIcon });
            marker.bindPopup(self.createPopupContent(store), { maxWidth: 250 });
            marker.on('click', function () { self.highlightStoreCard(index); });
            return marker;
        });
        this.markerGroup.clearLayers();
        this.markers.forEach(function (marker) { self.markerGroup.addLayer(marker); });
    };

    ParasStoreLocator.prototype.updateMarkers = function () {
        this.markerGroup.clearLayers();
        this.addMarkers();
    };

    ParasStoreLocator.prototype.createPopupContent = function (store) {
        var address = [store.address1, store.address2];
        if (store.city || store.state || store.postalCode) {
            address.push((store.city || '') + ', ' + (store.state || '') + ' ' + (store.postalCode || ''));
        }
        if (store.country) address.push(store.country);
        address = address.filter(Boolean).join('<br>');
        var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent((store.address1 || '') + ' ' + (store.city || '') + ' ' + (store.state || '') + ' ' + (store.postalCode || ''));
        var html = '<div class="paras-popup">';
        html += '<h4 class="paras-popup-name">' + this.escapeHtml(store.name) + '</h4>';
        html += '<div class="paras-popup-address">' + address + '</div>';
        if (store.phone) html += '<a href="tel:' + store.phone + '" class="paras-popup-phone">' + this.escapeHtml(store.phone) + '</a>';
        html += '<a href="' + directionsUrl + '" target="_blank" rel="noopener noreferrer" class="paras-popup-directions">Directions</a>';
        html += '</div>';
        return html;
    };

    ParasStoreLocator.prototype.selectStore = function (index) {
        var store = this.filteredStores[index];
        if (!store || !this.markers[index]) return;
        this.map.setView([store.lat, store.lng], 14);
        this.markers[index].openPopup();
        this.highlightStoreCard(index);
    };

    ParasStoreLocator.prototype.highlightStoreCard = function (index) {
        this.container.querySelectorAll('.paras-store-card-active').forEach(function (card) {
            card.classList.remove('paras-store-card-active');
        });
        var card = this.container.querySelector('[data-store-index="' + index + '"]');
        if (card) {
            card.classList.add('paras-store-card-active');
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    };

    ParasStoreLocator.prototype.fitMapToStores = function () {
        if (this.filteredStores.length === 0) {
            this.map.setView(CONFIG.mapCenter, CONFIG.mapZoom);
            return;
        }
        var bounds = L.latLngBounds(this.filteredStores.map(function (store) { return [store.lat, store.lng]; }));
        this.map.fitBounds(bounds, { padding: [30, 30], maxZoom: 12 });
    };

    ParasStoreLocator.prototype.updateResultsCount = function () {
        var countEl = this.container.querySelector('.paras-store-count');
        if (countEl) {
            countEl.textContent = this.filteredStores.length + ' location' + (this.filteredStores.length !== 1 ? 's' : '');
        }
    };

    ParasStoreLocator.prototype.showError = function (message) {
        var listInner = this.container.querySelector('.paras-store-list-items');
        if (listInner) {
            listInner.innerHTML = '<div class="paras-store-error">' + this.escapeHtml(message) + '</div>';
        }
    };

    ParasStoreLocator.prototype.escapeHtml = function (str) {
        if (!str) return '';
        var div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };

    function initParasStoreLocators() {
        document.querySelectorAll('.paras-store-locator').forEach(function (container) {
            new ParasStoreLocator(container);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initParasStoreLocators);
    } else {
        initParasStoreLocators();
    }
})();
